import React from 'react';

interface PageMetaProps {
    title: string;
    description: string;
    keywords?: string;
    ogImage?: string;
    ogType?: string;
}

const PageMeta: React.FC<PageMetaProps> = ({
    title,
    description,
    keywords,
    ogImage,
    ogType = 'website',
}) => {
    const fullTitle = `${title} | MotorPlan`;

    return (
        <>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={ogType} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {ogImage && <meta property="og:image" content={ogImage} />}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {ogImage && <meta name="twitter:image" content={ogImage} />}
        </>
    );
};

export default PageMeta;
